{
  "about.blocks": "Servī moderātī",
  "about.contact": "Ratio:",
  "about.default_locale": "Default",
  "about.disclaimer": "Mastodon est software līberum, apertum fontem, et nōtam commercium Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Ratio abdere est",
  "about.domain_blocks.preamble": "Mastodon genērāliter sinit tē contentum ex aliīs servientibus in fedīversō vidēre et cum usoribus ab iīs interāgere. Haē sunt exceptionēs quae in hōc particulārī servientē factae sunt.",
  "about.domain_blocks.silenced.explanation": "Tua profilia atque tuum contentum ab hac serve praecipue non videbis, nisi explōrēs expresse aut subsequeris et optēs.",
  "about.domain_blocks.silenced.title": "Limitātus",
  "about.domain_blocks.suspended.explanation": "Nulla data ab hōc servientē processābuntur, servābuntur aut commūtābuntur, faciendumque omnem interactionem aut communicātiōnem cum usoribus ab hōc servientē impossibilem.",
  "about.domain_blocks.suspended.title": "suspensus",
  "about.language_label": "Linguae",
  "about.not_available": "Haec informātiō in hōc servientē nōn praebita est.",
  "about.powered_by": "Nuntii socīālēs decentralizātī ā {mastodon} sustentātī.",
  "about.rules": "Servo praecepta",
  "account.account_note_header": "Nota personalia",
  "account.add_or_remove_from_list": "Adde aut ēripe ex tabellīs",
  "account.badges.bot": "Robotum",
  "account.badges.group": "Congregatio",
  "account.block": "Impedire @{name}",
  "account.block_domain": "Imperire dominium {domain}",
  "account.block_short": "Imperire",
  "account.blocked": "Impeditum est",
  "account.cancel_follow_request": "Petitio sequī retrāhere",
  "account.copy": "Transcribo connexi ut catagraphum",
  "account.direct": "Callim loqui @{name}",
  "account.disable_notifications": "Desine me certiorem facere cum @{name} scribit",
  "account.edit_profile": "Recolere notionem",
  "account.enable_notifications": "Desine me certiorem facere cum @{name} scribit",
  "account.endorse": "Notatio in profilo",
  "account.familiar_followers_many": "Secuti sunt {name1}, {name2}, et {othersCount, plural, one {alius quem nosti} other {# alii quos nosti}}",
  "account.familiar_followers_one": "Sequitur {name1}",
  "account.familiar_followers_two": "Sequitur {name1} et {name2}",
  "account.featured": "Praeclara",
  "account.featured.accounts": "Profilia",
  "account.follow": "Sequere",
  "account.follow_back": "Sequere retro",
  "account.followers": "Sectatores",
  "account.followers.empty": "Nemo hunc usorem adhuc sequitur.",
  "account.followers_counter": "{count, plural, one {{counter} sectator} other {{counter} sectatores}}",
  "account.followers_you_know_counter": "{counter} scis",
  "account.following": "Sequentia",
  "account.following_counter": "{count, plural, one {{counter} sectans} other {{counter} sectans}}",
  "account.follows.empty": "Hic usor adhuc neminem sequitur.",
  "account.follows_you": "Sequitur te",
  "account.go_to_profile": "Vade ad profile",
  "account.moved_to": "{name} significavit eum suam rationem novam nunc esse:",
  "account.muted": "Confutatus",
  "account.requested_follow": "{name} postulavit ut te sequeretur",
  "account.unblock_short": "Solvere impedimentum",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.retention.average": "Mediocritas",
  "admin.impact_report.instance_accounts": "Rationes perfiles hoc deleret",
  "alert.unexpected.message": "Error inopinatus occurrit.",
  "announcement.announcement": "Proclamatio",
  "attachments_list.unprocessed": "(immūtātus)",
  "boost_modal.combo": "Potes premēre {combo} ut hoc iterum transilīre",
  "bundle_column_error.error.title": "Eheu!",
  "bundle_column_error.retry": "Retemptare",
  "bundle_column_error.routing.title": "CCCCIIII",
  "bundle_modal_error.close": "Claudere",
  "bundle_modal_error.retry": "Retemptare",
  "column.about": "De",
  "column.bookmarks": "Signa paginales",
  "column.home": "Domi",
  "column.lists": "Catalogi",
  "column.pins": "Pinned post",
  "community.column_settings.media_only": "Media only",
  "compose.language.change": "Mutare linguam",
  "compose.language.search": "Quaerere linguas...",
  "compose_form.direct_message_warning_learn_more": "Discere plura",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Tua ratio non est {locked}. Quisquis te sequi potest ut visum accipiat nuntios tuos tantum pro sectatoribus.",
  "compose_form.lock_disclaimer.lock": "clausum",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Adde praeconium contentūs",
  "confirmations.block.confirm": "Impedire",
  "confirmations.delete.confirm": "Oblitterare",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete_list.confirm": "Oblitterare",
  "confirmations.discard_edit_media.message": "Habēs mutationēs in descriptionem vel prōspectum medii quae nōn sunt servātae; eas dēmittam?",
  "confirmations.mute.confirm": "Confutare",
  "disabled_account_banner.account_settings": "Praeferentiae ratiōnis",
  "disabled_account_banner.text": "Ratio tua {disabledAccount} debilitata est.",
  "domain_block_modal.you_wont_see_posts": "Nuntios aut notificātiōnēs ab usoribus in hōc servō nōn vidēbis.",
  "domain_pill.activitypub_like_language": "ActivityPub est velut lingua quam Mastodon cum aliīs sociālibus rētibus loquitur.",
  "domain_pill.your_handle": "Tuus nominulus:",
  "domain_pill.your_server": "Tua domus digitalis, ubi omnia tua nuntia habitant. Hanc non amas? Servēs trānsferāre potes quōcumque tempore et sectātōrēs tuōs simul addūcere.",
  "domain_pill.your_username": "Tuō singulāre id indicium in hōc servō est. Est possibile invenīre usōrēs cum eōdem nōmine in servīs aliīs.",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "emoji_button.activity": "Actiō",
  "emoji_button.food": "Cibus et potus",
  "emoji_button.people": "Homines",
  "emoji_button.search": "Quaerere...",
  "empty_column.account_suspended": "Rātiō suspēnsa",
  "empty_column.account_timeline": "Hic nulla contributa!",
  "empty_column.account_unavailable": "Notio non impetrabilis",
  "empty_column.blocks": "Nondum quemquam usorem obsēcāvisti.",
  "empty_column.bookmarked_statuses": "Nūllae adhuc postēs notātī habēs. Ubi unum notāverīs, hic apparebit.",
  "empty_column.direct": "Nōn habēs adhūc ullo mentionēs prīvātās. Cum ūnam mīseris aut accipis, hīc apparēbit.",
  "empty_column.favourited_statuses": "Nūllae adhuc postēs praeferendī habēs. Ubi unum praeferās, hic apparebit.",
  "empty_column.follow_requests": "Nūllae adhuc petitionēs sequendi habēs. Ubi unum accipīs, hic apparebit.",
  "empty_column.followed_tags": "Nōn adhūc aliquem hastāginem secūtus es. Cum id fēceris, hic ostendētur.",
  "empty_column.home": "Tua linea temporum domesticus vacua est! Sequere plures personas ut eam compleas.",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "empty_column.mutes": "Nondum quemquam usorem tacuisti.",
  "empty_column.notification_requests": "Omnia clara sunt! Nihil hic est. Cum novās notificātiōnēs accipīs, hic secundum tua praecepta apparebunt.",
  "empty_column.notifications": "Nōn adhūc habēs ullo notificātiōnēs. Cum aliī tē interagunt, hīc videbis.",
  "explore.trending_statuses": "Contributa",
  "firehose.all": "Omnis",
  "footer.about": "De",
  "generic.saved": "Servavit",
  "hashtag.column_header.tag_mode.none": "sine {additional}",
  "hashtag.column_settings.tag_mode.all": "Haec omnia",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} particeps} other {{counter} participēs}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} nuntius} other {{counter} nuntii}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} nuntius} other {{counter} nuntii}} hodie",
  "hashtags.and_other": "…et {count, plural, other {# plus}}",
  "ignore_notifications_modal.filter_to_act_users": "Adhuc poteris accipere, reicere, vel referre usores",
  "ignore_notifications_modal.filter_to_review_separately": "Percolantur notificatiōnes separātim recensere potes",
  "intervals.full.days": "{number, plural, one {# die} other {# dies}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horae}}",
  "intervals.full.minutes": "{number, plural, one {# minutum} other {# minuta}}",
  "keyboard_shortcuts.back": "Re navigare",
  "keyboard_shortcuts.blocked": "Aperire listam usorum obstructorum",
  "keyboard_shortcuts.boost": "Inlustrare publicatio",
  "keyboard_shortcuts.column": "Columnam dirigere",
  "keyboard_shortcuts.compose": "TextArea Compositi Attendere",
  "keyboard_shortcuts.description": "Descriptio",
  "keyboard_shortcuts.down": "In īndice dēscend",
  "keyboard_shortcuts.enter": "Aperire contributum",
  "keyboard_shortcuts.federated": "Aperī chrōnologiam foederātam",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "Aperī chrōnologiam domesticam",
  "keyboard_shortcuts.legend": "Hanc legendam ostende",
  "keyboard_shortcuts.local": "Aperī chrōnologiam locālem",
  "keyboard_shortcuts.mention": "Memēntō auctōris",
  "keyboard_shortcuts.muted": "Aperī indicem ūtentium silentiōrum",
  "keyboard_shortcuts.my_profile": "Aperī prōfilum tuum",
  "keyboard_shortcuts.notifications": "Aperī columnam nūntiātiōnum",
  "keyboard_shortcuts.open_media": "Aperi media",
  "keyboard_shortcuts.pinned": "Aperī indicem nūntiōrum affixōrum",
  "keyboard_shortcuts.profile": "Aperi auctoris profile",
  "keyboard_shortcuts.reply": "Respondere ad contributum",
  "keyboard_shortcuts.requests": "Aperī indicem petītiōnum sequendī",
  "keyboard_shortcuts.search": "Fōcum in tabellam quaerendī",
  "keyboard_shortcuts.spoilers": "Ostende / celare CW agri",
  "keyboard_shortcuts.start": "Aperī columnam 'īncipere'",
  "keyboard_shortcuts.toggle_hidden": "Monstrare / celare textum post CW",
  "keyboard_shortcuts.toggle_sensitivity": "Ostende / celare media",
  "keyboard_shortcuts.toot": "Incipe nōvum nūntium.",
  "keyboard_shortcuts.unfocus": "Desinēre fōcum in ārēā componendī/inquīrendī",
  "keyboard_shortcuts.up": "Sumē sūrsum in īndice",
  "lightbox.close": "Claudere",
  "lightbox.next": "Secundum",
  "load_pending": "{count, plural, one {# novum item} other {# nova itema}}",
  "moved_to_account_banner.text": "Tua ratione {disabledAccount} interdum reposita est, quod ad {movedToAccount} migrāvisti.",
  "mute_modal.you_wont_see_mentions": "Non videbis nuntios quī eōs commemorant.",
  "navigation_bar.about": "De",
  "navigation_bar.domain_blocks": "Hidden domains",
  "not_signed_in_indicator.not_signed_in": "Ad hunc locum pervenire oportet ut inīre facias.",
  "notification.admin.report": "{name} nuntiavit {target}",
  "notification.admin.sign_up": "{name} subscripsit",
  "notification.favourite": "{name} nuntium tuum favit",
  "notification.follow": "{name} te secutus est",
  "notification.follow_request": "{name} postulavit ut te sequeretur",
  "notification.moderation_warning": "Accepistī monitionem moderationis",
  "notification.moderation_warning.action_disable": "Ratio tua debilitata est.",
  "notification.moderation_warning.action_none": "Tua ratiō monitum moderātiōnis accēpit.",
  "notification.moderation_warning.action_sensitive": "Tua nuntia hinc sensibiliter notabuntur.",
  "notification.moderation_warning.action_silence": "Ratio tua est limitata.",
  "notification.moderation_warning.action_suspend": "Ratio tua suspensus est.",
  "notification.own_poll": "Suffragium tuum terminatum est",
  "notification.reblog": "{name} tuum nuntium amplificavit.",
  "notification.relationships_severance_event.account_suspension": "Admin ab {from} {target} suspendit, quod significat nōn iam posse tē novitātēs ab eīs accipere aut cum eīs interagere.",
  "notification.relationships_severance_event.domain_block": "Admin ab {from} {target} obsēcāvit, includēns {followersCount} ex tuīs sectātōribus et {followingCount, plural, one {# ratione} other {# rationibus}} quās sequeris.",
  "notification.relationships_severance_event.user_domain_block": "Bloqueāstī {target}, removēns {followersCount} ex sectātōribus tuīs et {followingCount, plural, one {# rationem} other {# rationēs}} quōs sequeris.",
  "notification.status": "{name} nuper publicavit",
  "notification.update": "{name} nuntium correxit",
  "notification_requests.accept": "Accipe",
  "notification_requests.confirm_accept_multiple.message": "Tu es accepturus {count, plural, one {una notitia petitionem} other {# notitia petitiones}}. Certus esne procedere vis?",
  "notification_requests.confirm_dismiss_multiple.message": "Tu {count, plural, one {unam petitionem notificationis} other {# petitiones notificationum}} abrogāre prōximum es. {count, plural, one {it} other {Eae}} facile accessū nōn erit. Certus es tē procedere velle?",
  "notifications.filter.all": "Omnia",
  "notifications.filter.polls": "Eventus electionis",
  "notifications.group": "{count} Notificātiōnēs",
  "onboarding.profile.display_name_hint": "Tuum nomen completum aut tuum nomen ludens…",
  "onboarding.profile.note_hint": "Alios hominēs vel #hashtags @nōmināre potes…",
  "poll.closed": "Clausum",
  "poll.total_people": "{count, plural, one {# persona} other {# personae}}",
  "poll.total_votes": "{count, plural, one {# suffragium} other {# suffragia}}",
  "poll.vote": "Eligere",
  "poll.voted": "Elegisti hoc responsum",
  "poll.votes": "{votes, plural, one {# sufragium} other {# sufragia}}",
  "poll_button.add_poll": "Addere electionem",
  "poll_button.remove_poll": "Auferre electionem",
  "privacy.change": "Adjust status privacy",
  "privacy.public.short": "Coram publico",
  "relative_time.full.days": "{number, plural, one {# ante die} other {# ante dies}}",
  "relative_time.full.hours": "{number, plural, one {# ante horam} other {# ante horas}}",
  "relative_time.full.just_now": "nunc",
  "relative_time.full.minutes": "{number, plural, one {# ante minutum} other {# ante minuta}}",
  "relative_time.full.seconds": "{number, plural, one {# ante secundum} other {# ante secunda}}",
  "relative_time.just_now": "nunc",
  "relative_time.today": "hodie",
  "reply_indicator.attachments": "{count, plural, one {# annexus} other {# annexūs}}",
  "report.block": "Impedimentum",
  "report.block_explanation": "Non videbis eorum nuntios. Non poterunt vidēre tuōs nuntios aut tē sequī. Intelligere poterunt sē obstrūctōs esse.",
  "report.categories.other": "Altera",
  "report.category.title_account": "notio",
  "report.category.title_status": "contributum",
  "report.close": "Confectum",
  "report.mute": "Confutare",
  "report.mute_explanation": "Non videbis eōrum nuntiōs. Possunt adhuc tē sequī et tuōs nuntiōs vidēre, nec sciēbunt sē tacitōs esse.",
  "report.next": "Secundum",
  "report.placeholder": "Commentāriī adiūnctī",
  "report.reasons.legal_description": "Putās id legem tuae aut servientis patriae violāre",
  "report.reasons.violation_description": "Scis quod certa praecepta frangit",
  "report.submit": "Mittere",
  "report.target": "Report {target}",
  "report.unfollow_explanation": "Tu hanc rationem secutus es. Non videre stationes suas in domo tua amplius pascere, eas sequere.",
  "report_notification.attached_statuses": "{count, plural, one {{count} nuntius} other {{count} nuntii}} attachiatus",
  "report_notification.categories.other": "Altera",
  "search.placeholder": "Quaerere",
  "search_results.all": "Omnis",
  "server_banner.active_users": "usūāriī āctīvī",
  "server_banner.administered_by": "Administratur:",
  "server_banner.is_one_of_many": "{domain} est unum ex multis independentibus servientibus Mastodon quos adhibere potes ut participes in fediverso.",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "Impedire @{name}",
  "status.bookmark": "Signa paginaris",
  "status.continued_thread": "Filum continuum",
  "status.copy": "Copy link to status",
  "status.delete": "Oblitterare",
  "status.delete.success": "Nuntius deletus",
  "status.detailed_status": "Conspectus colloquii accuratus",
  "status.direct": "Privatim mentionem fac @{name}",
  "status.direct_indicator": "Mentiō Privāta",
  "status.edit": "Recolere",
  "status.edited": "Novissime editum {date}",
  "status.edited_x_times": "Emendatum est {count, plural, one {{count} tempus} other {{count} tempora}}",
  "status.embed": "Codicem insitum accipe",
  "status.favourite": "Dilectum",
  "status.favourites_count": "{count, plural, one {{counter} dilectum} other {{counter} dilecti}}",
  "status.filter": "Hanc nuntium filtra",
  "status.history.created": "{name} creatum {date}",
  "status.history.edited": "{name} correxit {date}",
  "status.load_more": "Onera plura",
  "status.media.open": "Preme ut aperias",
  "status.media.show": "Preme ut ostendat",
  "status.media_hidden": "Media occulta",
  "status.mention": "Mentionem fac @{name}",
  "status.more": "Plus",
  "status.mute": "Tace @{nomen}",
  "status.mute_conversation": "Colloquium mutus",
  "status.open": "Hanc nuntium expande",
  "status.quote": "Citatio",
  "status.quote.cancel": "Abrogare citatio",
  "status.quote_error.blocked_account_hint.title": "Hoc nuntium celatur, quia @{name} obsignavisti.",
  "status.quote_error.blocked_domain_hint.title": "Hoc nuntium celatur, quia {domain} obsignavisti.",
  "status.quote_error.filtered": "Occultus ob unum e tuis Filtra",
  "status.quote_error.limited_account_hint.action": "Monstrā nihilōminus",
  "status.quote_error.limited_account_hint.title": "Haec ratio a moderatoribus {domain} occultata est.",
  "status.quote_error.muted_account_hint.title": "Hoc nuntium celatur, quia @{name} mutum fecisti.",
  "status.quote_error.not_available": "Nullus nuntius",
  "status.quote_error.pending_approval": "Nuntius in approbatione",
  "status.quote_error.pending_approval_popout.body": "In Mastodon, moderari potes utrum aliquis te citare possit. Hoc nuntium pendet dum approbationem auctoris originalis impetramus.",
  "status.quote_error.revoked": "Commentarius ab auctore remotus",
  "status.quote_followers_only": "Tantum sequaces hanc scriptionem citare possunt.",
  "status.quote_manual_review": "Auctor manu recognoscet",
  "status.quote_noun": "Citatio",
  "status.quote_policy_change": "Muta qui citare possit",
  "status.quote_post_author": "Commentarium @{name} citatum.",
  "status.quote_private": "Nuntii privati citari non possunt.",
  "status.quotes.empty": "Nemo hanc commentationem adhuc citavit. Cum quis citaverit, hic apparebit.",
  "status.quotes.local_other_disclaimer": "Citationes ab auctore reiec­tæ non monstrabuntur.",
  "status.quotes.remote_other_disclaimer": "Tantum citae ex {domain} hic exhiberi praestantur. Citae ab auctore reiectae non exhibebuntur.",
  "status.quotes_count": "{count, plural, one {{counter} citatio} other {{counter} citationes}}",
  "status.read_more": "Plura lege",
  "status.reblog": "Promovere",
  "status.reblog_or_quote": "Promovere aut cita",
  "status.reblog_private": "Iterum cum sectatoribus tuis communica",
  "status.reblogged_by": "{name} adiuvavit",
  "status.reblogs.empty": "Nemo hanc publicationem adhuc promovit. Cum quis eam promoveat, hic apparebunt.",
  "status.reblogs_count": "{count, plural, one {{counter} incrementum} other {{counter} incrementa}}",
  "status.redraft": "Dele et redig",
  "status.remove_bookmark": "Tolle signum",
  "status.remove_favourite": "Tolle ad delectis",
  "status.remove_quote": "Tolle",
  "status.replied_in_thread": "In filo responsum",
  "status.replied_to": "{name} respondit",
  "status.reply": "Respondere",
  "status.replyAll": "Responde ad filum",
  "status.report": "Referre @{name}",
  "status.request_quote": "Pretium petere",
  "status.revoke_quote": "Tolle nuntium meum ex nuntio @{name}",
  "status.sensitive_warning": "Materia delicata",
  "status.share": "Communica",
  "status.show_less_all": "Omnibus minus monstra",
  "status.show_more_all": "Omnibus plura monstra",
  "status.show_original": "Monstra originalem",
  "status.title.with_attachments": "{user} publicavit {attachmentCount, plural, one {unum annexum} other {{attachmentCount} annexa}}",
  "status.translate": "Converte",
  "status.translated_from_with": "Translatum ex {lang} per {provider}",
  "status.uncached_media_warning": "Praevisum non praesto est",
  "status.unmute_conversation": "Conversationem reserare",
  "subscribed_languages.lead": "Tantum epistolae in linguis selectis in domo tua apparebunt et indices temporum post mutationem. Neminem eligatis qui epistolas in omnibus linguis recipiat.",
  "subscribed_languages.save": "Servare mutationes",
  "subscribed_languages.target": "Muta linguas subscriptas pro {target}",
  "tabs_bar.home": "Domi",
  "tabs_bar.menu": "Elenchus",
  "tabs_bar.notifications": "Acta Vicimediorum",
  "tabs_bar.publish": "Nova publicatio",
  "tabs_bar.search": "Quaere",
  "tag.remove": "Tolle",
  "terms_of_service.effective_as_of": "Valet ex {date}",
  "terms_of_service.title": "Termini servitii",
  "terms_of_service.upcoming_changes_on": "Mutationes venturae die {date}",
  "time_remaining.days": "{number, plural, one {# die} other {# dies}} restant",
  "time_remaining.hours": "{number, plural, one {# hora} other {# horae}} restant",
  "time_remaining.minutes": "{number, plural, one {# minutum} other {# minuta}} restant",
  "time_remaining.moments": "Momenta reliqua",
  "time_remaining.seconds": "{number, plural, one {# secundum} other {# secunda}} restant",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persōna} other {{counter} persōnae}} in {days, plural, one {days} other {diēbus praeteritīs {days}}}",
  "trends.trending_now": "Nunc in usu",
  "ui.beforeunload": "Si Mastodon discesseris, tua epitome peribit.",
  "units.short.billion": "{count} millia milionum",
  "units.short.million": "{count} milionum",
  "units.short.thousand": "{count} millia",
  "upload_area.title": "Trahe et depone ad imponendum",
  "upload_button.label": "Adde imagines, pelliculam, aut fasciculum sonorum.",
  "upload_error.limit": "Limes onerationis superatus est.",
  "upload_error.poll": "Nullis suffragiis licet fascicula imponere.",
  "upload_error.quote": "Nullum oneramentum fasciculi cum citationibus permittitur.",
  "upload_form.drag_and_drop.instructions": "Ad annexum mediorum tollendum, preme clavem \"Space\" aut \"Enter\". Dum traheis, utere clavibus sagittariis ad annexum mediorum in quamlibet partem movendum. Preme iterum \"Space\" aut \"Enter\" ad annexum mediorum in novo loco deponendum, aut preme \"Escape\" ad desinendum.",
  "upload_form.drag_and_drop.on_drag_cancel": "Tractatio revocata est. Adiunctum medium {item} demissum est.",
  "upload_form.drag_and_drop.on_drag_end": "Adhaesum medium {item} demissum est.",
  "upload_form.drag_and_drop.on_drag_over": "Adhaesum medium {item} motum est.",
  "upload_form.drag_and_drop.on_drag_start": "Adhaesum medium {item} sublatum est.",
  "upload_form.edit": "Recolere",
  "upload_progress.label": "Oneratur...",
  "upload_progress.processing": "Processus…",
  "username.taken": "Illud nomen usoris occupatum est. Aliud tenta.",
  "video.close": "Pelliculam claude",
  "video.download": "Prehendere fasciculus",
  "video.exit_fullscreen": "Exitus ex plenum monitorium",
  "video.expand": "Expande pelliculam",
  "video.fullscreen": "Plenum monitorium",
  "video.hide": "celare pellicula",
  "video.mute": "Mutus",
  "video.pause": "intermittere",
  "video.play": "gignere",
  "video.skip_backward": "Redire",
  "video.skip_forward": "Progredi",
  "video.unmute": "Sordes tollere",
  "video.volume_down": "Volumen deminui",
  "video.volume_up": "Volumen augete",
  "visibility_modal.button_title": "Visibilitatem statuere",
  "visibility_modal.direct_quote_warning.text": "Si praesentia configuramenta servaveris, sententia inserta in nexum convertetur.",
  "visibility_modal.direct_quote_warning.title": "Citatio in mentitionibus privatis inseriri non possunt.",
  "visibility_modal.header": "Visibilitas et interactio",
  "visibility_modal.helper.direct_quoting": "Mentiones privatae in Mastodon scriptae ab aliis citari non possunt.",
  "visibility_modal.helper.privacy_editing": "Visibilitas mutari non potest postquam nuntius publicatus est.",
  "visibility_modal.helper.privacy_private_self_quote": "Citationes propriae nuntiorum privatorum publicari non possunt.",
  "visibility_modal.helper.private_quoting": "Nuntii in Mastodon a sequacibus tantum scriptī ab aliis citari non possunt.",
  "visibility_modal.helper.unlisted_quoting": "Cum te citant, eorum scriptum etiam ex indicibus popularibus celabitur.",
  "visibility_modal.instructions": "Régula quis cum hoc scripto agere possit. Potes etiam ordinationes omnibus scriptis futuris adhibere, navigando ad <link>Praeferentias > Regulas scriptionis praedefinitas</link>.",
  "visibility_modal.privacy_label": "Visibilitas",
  "visibility_modal.quote_followers": "Sectatores tantum",
  "visibility_modal.quote_label": "Quis citare potest",
  "visibility_modal.quote_nobody": "Sicut me",
  "visibility_modal.quote_public": "quisquis",
  "visibility_modal.save": "Servare"
}
